(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var menu = document.currentScript.previousElementSibling.previousElementSibling;
    while (menu && !menu.classList.contains('menu-glowne')) { menu = menu.previousElementSibling; }
    if (!menu) { return; }

    var listy = menu.querySelectorAll('details.menu-lista');
    if (!listy.length) { return; }

    function zamknijPozostale(otwarta) {
        for (var i = 0; i < listy.length; i++) {
            if (listy[i] !== otwarta) { listy[i].open = false; }
        }
    }

    for (var i = 0; i < listy.length; i++) {
        listy[i].addEventListener('toggle', function () {
            if (this.open) { zamknijPozostale(this); }
        });
    }

    menu.addEventListener('keydown', function (e) {
        if (e.key !== __pewniaki_inline_cfg[0]) { return; }
        var otwarta = menu.querySelector('details.menu-lista[open]');
        if (!otwarta) { return; }
        otwarta.open = false;
        var s = otwarta.querySelector('summary');
        if (s) { s.focus(); }
    });

    document.addEventListener('click', function (e) {
        if (menu.contains(e.target)) { return; }
        zamknijPozostale(null);
    });
})();
})();
